import type { DiscountValues } from './useDiscountValues';

// This is a temporary promotion so is fine to hardcode
export const FEE_ON_A_15000_VEHICLE = 389;

export const calculateDiscount = ({ percentageDiscount, purchaseThreshold }: DiscountValues) => {
	const feesOnThresholdVehicles = purchaseThreshold * FEE_ON_A_15000_VEHICLE;
	const totalSavings = (1 - (100 - percentageDiscount) / 100) * feesOnThresholdVehicles;

	return { feesOnThresholdVehicles, totalSavings };
};
